import { useGet } from 'restful-react';
import { getCountryOriginUrl, isGlobalSite } from '../helpers/countrySubdomainHelper';
import { useAuth0 } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useCountrySiteRouting = () => {
  const { isAuthenticated, logout } = useAuth0();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const { data: userDbLocale, refetch } = useGet({
    path: '/user/locale',
    lazy: true,
  });

  useEffect(() => {
    // Handle redirect to user's persisted locale inferred country site
    if (isAuthenticated) {
      if (!userDbLocale) {
        refetch();
      }
    } else {
      // handle case where user has lang pref but goes to old url via bookmark or similar so isn't authenticated (as they were
      // auth'd on the new country sub-domain)
      const lang = localStorage.getItem('languagePreference');
      if (lang) {
        const inferredCountry = new Intl.Locale(lang).region?.toString() || 'GB';
        const userCountryOrigin = getCountryOriginUrl({
          value: lang,
          label: '',
          inferredCountry,
          requiresPhysioConfirmation: false,
        });
        if (userCountryOrigin !== window.location.origin) {
          logout({ returnTo: userCountryOrigin });
        }
      }
      setLoading(false);
    }
    if (userDbLocale) {
      if (userDbLocale?.inferredCountry && !isGlobalSite) {
        const userCountryOrigin = getCountryOriginUrl(userDbLocale);
        if (userCountryOrigin !== window.location.origin) {
          logout({ returnTo: userCountryOrigin });
        } else {
          setLoading(false);
        }
      }
    }
  }, [isAuthenticated, userDbLocale, refetch, logout, navigate]);

  return loading;
};
